import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LogOut, QrCode } from "lucide-react";
import CheckinsPendientes from "@/components/admin/puntolimpio/CheckinsPendientes";
import EventosHistorial from "@/components/admin/puntolimpio/EventosHistorial";

export default function PuntoLimpioStaffDashboard() {
  const navigate = useNavigate();
  const [session, setSession] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("sfh_admin_session");
    if (!raw) { navigate("/admin"); return; }
    const parsed = JSON.parse(raw);
    if (parsed.rol !== "punto_limpio_staff") { navigate("/admin/dashboard"); return; }
    setSession(parsed);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("sfh_admin_token");
    localStorage.removeItem("sfh_admin_session");
    navigate("/admin");
  };

  if (!session) return null;

  return (
    <div className="min-h-screen bg-gray-50" data-testid="puntolimpio-staff-dashboard">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-municipal/10 flex items-center justify-center shrink-0">
              <QrCode className="w-5 h-5 text-municipal" />
            </div>
            <div>
              <p className="font-heading font-semibold text-municipal text-sm leading-tight">Punto Limpio Móvil — Check-ins</p>
              <p className="text-xs text-gray-400 leading-tight">{session.nombre}</p>
            </div>
          </div>
          <Button variant="outline" size="sm" onClick={handleLogout} className="border-municipal text-municipal" data-testid="puntolimpio-staff-logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Salir
          </Button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <Tabs defaultValue="pendientes">
          <TabsList className="mb-4">
            <TabsTrigger value="pendientes" data-testid="staff-subtab-pendientes">Check-ins pendientes</TabsTrigger>
            <TabsTrigger value="historico" data-testid="staff-subtab-historico">Histórico y salidas</TabsTrigger>
          </TabsList>
          <TabsContent value="pendientes"><CheckinsPendientes /></TabsContent>
          <TabsContent value="historico"><EventosHistorial /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
